import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useSectionStore = defineStore('section', {
  state: () => ({
    section: {
      id: null,
      title: '',
      slug: '',
      system_record: false,
      enabled: true,
      list_order: 0,
    }
  }),

  actions: {
    async fetch({ sectionId }) {
      return httpClient.get(`/api/internal/sections/${sectionId}`)
        .then(({ data: { section } }) => {
          this.section = section
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },

    async save() {
      return this.section.id ? this.update() : this.create()
    },

    async create() {
      const { section } = this

      return httpClient.post('/api/internal/sections', { section })
        .then(({ data: { section } }) => {
          this.section = section
          useMessagesStore().addNotice('Print section created')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async update() {
      const { section } = this

      return httpClient.patch(`/api/internal/sections/${section.id}`, { section })
        .then(({ data: { section } }) => {
          this.section = section
          useMessagesStore().addNotice('Print section saved')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async destroy() {
      const { id } = this.section

      return httpClient.delete(`/api/internal/sections/${id}`)
        .then(() => {
          this.$reset()
          useMessagesStore().addNotice('Print section deleted')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },
  }
})
